import { useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useSearchParams } from '../../campaigns/hooks/useSearchParams';
import { useKeyboardNavigation } from '../../../lib/hooks/useKeyboardNavigation';

export const useTileNavigation = ({ tile, campaignId }) => {
  const tiles = useSelector(state => {
    if (tile.campaignContainer.startsWith('post-')) {
      return Object.entries(state.campaignDnd).reduce((acc, [key, value]) => {
        if (key.includes('post')) {
          return [...acc, ...value];
        }
        return acc;
      }, []);
    }

    return state.campaignDnd[tile.campaignContainer] || [];
  });

  const arrowRightRef = useRef(null);
  const arrowLeftRef = useRef(null);

  const history = useHistory();
  const query = useSearchParams();
  const preview = query.get('preview');

  const currentPosition = tiles.map(({ id }) => id).indexOf(tile.id);
  const isLastTile = currentPosition === tiles.length - 1;
  const isFirstTile = currentPosition === 0;

  const nextTile = tiles[currentPosition + 1];
  const previousTile = tiles[currentPosition - 1];

  const goToNext = useCallback(() => {
    if (!nextTile) return;

    history.push(`./${nextTile.id}?preview=${preview}`);
  }, [history, nextTile, preview]);

  const goToPrevious = useCallback(() => {
    if (!previousTile) return;

    history.push(`./${previousTile.id}?preview=${preview}`);
  }, [history, preview, previousTile]);

  const isInPlanRouter = history.location.pathname.startsWith('/campaigns/');
  const prefix = isInPlanRouter ? '/campaigns' : '';

  const goToEdit = () =>
    history.push(`${prefix}/${campaignId}/edit/${tile.id}?preview=${preview}`);

  const goToPreview = () =>
    history.push(`${prefix}/${campaignId}/tile/${tile.id}?preview=${preview}`);

  const goBack = () => {
    const basePath =
      preview === 'true'
        ? `${prefix}/${campaignId}/preview`
        : `${prefix}/${campaignId}/edit`;
    const calendarParams = new URLSearchParams();
    const from = query.get('from');
    const cy = query.get('cy');
    const cm = query.get('cm');
    const hf = query.get('hf');
    const bf = query.get('bf');
    if (from) calendarParams.set('from', from);
    if (cy) calendarParams.set('cy', cy);
    if (cm !== null && cm !== undefined && cm !== '')
      calendarParams.set('cm', cm);
    if (hf) calendarParams.set('hf', hf);
    if (bf) calendarParams.set('bf', bf);
    const qs = calendarParams.toString();
    history.push(qs ? `${basePath}?${qs}` : basePath);
  };

  const goToRoot = () => {
    history.push('/');
  };

  useKeyboardNavigation({
    arrowLeftRef,
    arrowRightRef,
  });

  return {
    isFirstTile,
    isLastTile,
    goToNext,
    goToPrevious,
    goToEdit,
    goToPreview,
    goBack,
    goToRoot,
    arrowRightRef,
    arrowLeftRef,
  };
};
